<template>
  <div v-if="!isEmpty(events) && !selected.isSearch" class="footer-day-selector">
    <div class="button-previous" @click="onClickPrevious()">
      <div class="arrow arrow-left" />
      <div class="label">
        {{ getPrevisousText() }}
      </div>
    </div>
    <div class="button-next" @click="onClickNext()">
      <div class="label">
        {{ getNextText() }}
      </div>
      <div class="arrow arrow-right" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import TranslateService from '@/services/TranslateService'
import Base from '@/components/Base'

export default {
  mixins: [
    Base
  ],
  props: [
    'selected',
    'events'
  ],
  data () {
    return {
      isEmpty: _.isEmpty,
      maxDay: 9,
      dayList: []
    }
  },
  async mounted () {
    this.updateDayList()
  },
  methods: {
    async updateDayList () {
      this.dayList = _.map(_.range(this.maxDay), idx => {
        const diff = idx - Math.floor(this.maxDay / 2)
        const boxDate = moment(this.selected.date).add(diff, 'd')
        return {
          diff,
          selected: diff === 0,
          date: boxDate.format('YYYY-MM-DD'),
          day: boxDate.format('D'),
          weekDay: this.$filters.translate(`T_WEEK_DAY_${boxDate.weekday()}`),
          numOfEvents: 0
        }
      })
    },
    onClickPrevious () {
      this.$parent.scrollToDaySelector()
      const numDay = this.selected.duration === 'week' ? 7 : 1
      const newDate = moment(this.selected.date).add(-numDay, 'd').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    },
    onClickNext () {
      this.$parent.scrollToDaySelector()
      const numDay = this.selected.duration === 'week' ? 7 : 1
      const newDate = moment(this.selected.date).add(numDay, 'd').format('YYYY-MM-DD')
      _.set(this.selected, 'date', newDate)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    },
    getPrevisousText () {
      if (this.selected.duration === 'week') {
        return this.$filters.translate('T_PREVIOUS_WEEK')
      }
      const newDate = moment(this.selected.date).add(-1, 'd').format('YYYY-MM-DD')

      if (TranslateService.currentLocale === 'en') {
        const monthText = _.toUpper(this.$filters.translate(`T_${moment(newDate).format('MMM')}`))
        return `${moment(newDate).format('D')} ${monthText}`
      } else {
        return [
          moment(newDate).format('M'),
          this.$filters.translate('T_MONTH'),
          moment(newDate).format('D'),
          this.$filters.translate('T_DAY')
        ].join('')
      }
    },
    getNextText () {
      if (this.selected.duration === 'week') {
        return this.$filters.translate('T_NEXT_WEEK')
      }
      const newDate = moment(this.selected.date).add(1, 'd').format('YYYY-MM-DD')

      return this.getDateText(newDate)
    }

  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.footer-day-selector {
  // border: 1px red solid;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0px;
  white-space: nowrap;
}

.button-previous, .button-next {
  // position: absolute;
  cursor: pointer;
  display: flex;
  align-items: center;
  // border: 1px green solid;
  &.button-previous {
    left: 0px;
  }
  &.button-next {
    right: 0px;
  }

  .label {
    display: inline-block;
    margin: 0px 8px;
    color: #333333;
    font-size: 16px;
  }

  &:hover {
    .arrow {
      border-color: $color-light-blue;
    }
    .label {
      color: #888888;
    }
  }
}

.arrow {
  border: solid $color-hkbu-blue-background;
  border-width: 0 5px 5px 0;
  display: inline-block;
  padding: 8px;
}
.arrow-left {
  margin-left: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
.arrow-right {
  margin-right: 5px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.overflow-container {
  // border: 1px red solid;
  min-height: 154px;
  margin: 0px 30px;
  overflow: hidden;
}

@media screen and (max-width: 768px)
{
  .footer-day-selector {
    padding: 25px 25px;
    padding-bottom: 60px;
  }
}

</style>
